export default __webpack_public_path__ + "static/media/Ekjot-horizontal.adaffefe.jpg";